import { frontendURL } from '../../../../helper/URLHelper';
import { isFeatureFlagEnabledForAccount } from '../../../../helper/featureFlagHelper';
import store from '../../../../store';
import { REDIS_FEATURE_FLAGS } from '../../../../featureFlags';
const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

// The global guard (`routeHelpers.js`) only checks `meta.permissions`, never
// the feature flag, so with the flag off the sidebar item hides but the URL
// stays typeable. Gate the route too, the same way the Improvement Center does
// (claudia.routes.js) -- the API answers 404 for these accounts anyway, and an
// admin should land somewhere real instead of on an empty screen.
//
// Read from `currentUser.accounts`, not the accounts store: the `accounts/get`
// payload drops `feature_flags` from `custom_attributes`, and during
// `beforeEnter` the current-account getter still points at the previous
// account. `setUser` resolves before the first navigation, so this source is
// populated even on a deep link into the URL.
const isBillingEstimateEnabled = accountId => {
  const accounts = store.getters.getCurrentUser?.accounts || [];
  const account = accounts.find(({ id }) => id === Number(accountId));
  return isFeatureFlagEnabledForAccount(
    account,
    REDIS_FEATURE_FLAGS.BILLING_ESTIMATE
  );
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/billing'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsContent,
      props: {
        headerTitle: 'BILLING_SETTINGS.TITLE',
        icon: 'credit-card-person',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'billing_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
          beforeEnter: (to, _from, next) => {
            if (!isBillingEstimateEnabled(to.params.accountId)) {
              next({
                name: 'general_settings_index',
                params: { accountId: to.params.accountId },
              });
              return;
            }
            next();
          },
        },
      ],
    },
  ],
};
